import { Typography } from "@mui/material";
import "dayjs/locale/cs";
import type { FC } from "react";

type Props = {
	text: string;
	onClick: () => void;
};

export const ActivitiesFilterDateItem: FC<Props> = ({ text, onClick }) => (
	<Typography
		fontSize={15}
		fontWeight={500}
		padding="3px 8px"
		onClick={onClick}
	>
		{text}
	</Typography>
);
